import {FigmaElement} from "@/includes/fig-parser/models/base/figma-element";
import {FIG_DATA_TYPE_TO_MODEL} from "@/includes/fig-parser/constants";

export class FigmaFolder extends FigmaElement {
  /**
   * @type {FigmaElement[]}
   */
  children;
  
  constructor(element) {
    super(element);
    this.children = this._mapChildren(element.children);
  }
  
  _mapChildren(children) {
    return children.map(element => {
      const loader = FIG_DATA_TYPE_TO_MODEL[element.type];
      const Klass = loader();
      return new Klass(element);
    })
  }
}
